




















































































import { defineComponent, PropType, ref } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import RadioButton from '@front-app/components/inputs/RadioButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { CustomPageLayout } from '@front-app/modules/group/highlights/model';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: {
		CtaButton,
		RadioButton,
	},
	props: {
		selectedLayout: {
			type: String as PropType<CustomPageLayout>,
			required: true,
		},
		numberOfColumns: {
			type: Number,
			required: true,
		},
	},
	setup(props) {
		const selectedLayoutLocal = ref(props.selectedLayout);

		return {
			CustomPageLayout,
			selectedLayoutLocal,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
